import {
  useTypedParams,
  useTypedSearchParams,
} from "react-router-typesafe-routes";

import { EmployeeDashboard as EmployeeDashboardComponent } from "@components/Dashboards";

import { routes } from "@pages/routes";

export const ClientEmployeeDashboard = () => {
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee.dashboard,
  );
  const [{ applicationResourceId }] = useTypedSearchParams(
    routes.portal.clients.client.clientEmployees.clientEmployee.dashboard,
  );

  return (
    <EmployeeDashboardComponent
      clientId={clientId}
      clientEmployeeId={clientEmployeeId}
      initialApplicationResourceId={applicationResourceId || undefined}
    />
  );
};
